import { render, staticRenderFns } from "./LoanDetailsActivity.vue?vue&type=template&id=18928825&scoped=true&"
import script from "./LoanDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./LoanDetailsActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=18928825&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18928825",
  null
  
)

export default component.exports